import Vue from "./common/vue-common";
import HorizontalScrollbar from "./components/common/container/HorizontalScrollbar";

export const getSimpleVueHorizontalScroll = el => new Vue({
    el,
    components: {HorizontalScrollbar},
    data() {
        return {
            scrollEvent: null,
        }
    }
});